import { EnumerationFundLocationInterface } from '../interfaces/enumeration.fundlocation.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('EnumerationFundLocationModel')
export class EnumerationFundLocationModel
  implements EnumerationFundLocationInterface
{
  @JsonProperty('Code', String, true)
  code: string = undefined;

  @JsonProperty('Description', String, true)
  description: string = undefined;

  @JsonProperty('Id', String, true)
  id: string = undefined;
}
